import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback
} from "reactstrap";

import { withRouter, useHistory, Link } from "react-router-dom";

import * as Yup from "yup";
import { useFormik } from "formik";

import Breadcrumb from "../../components/Common/Breadcrumb";
import "../../assets/scss/custom/style.css";
import Snackbars from "../../Utils/Snackbars";
import useRequests from "../../Utils/useRequests";

const UserProfile = () => {
  document.title = "Profile";
  const { getRequest, postRequest } = useRequests();
  const history = useHistory();

  const [AlertData, setAlertData] = useState({
    variant: "",
    message: "",
  });

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData({
        variant: "",
        message: "",
      });
    }, 5000);
  };

  const [userType, setUserType] = useState("");

  const validation1 = useFormik({
    enableReinitialize: true,
    initialValues: {
      first_name: "",
      last_name: "",
      userid: "",
      organization_name: "",
      location: "",
      supervisor: "",
      email: "",
      mobile: "",
    },
    validationSchema: () =>
      Yup.object({
        first_name: userType !== 'organization'
          ? Yup.string().required("First Name is required")
          : Yup.string().nullable(),
        last_name: userType !== 'organization'
          ? Yup.string().required("Last Name is required")
          : Yup.string().nullable(),
        userid: Yup.string().required("User Name is required"),
        organization_name: userType !== 'admin'
          ? Yup.string().required("Organization Name is required")
          : Yup.string().nullable(),
        location: userType !== 'admin'
          ? Yup.string().required("Location is required")
          : Yup.string().nullable(),
        supervisor: userType !== 'admin'
          ? Yup.string().required("Supervisor is required")
          : Yup.string().nullable(),
        email: Yup.string().email("Invalid email").required("Email is required"),
        mobile: Yup.string()
          .required("Mobile Number is required")
          .matches(/^[0-9]+$/, "Mobile number must be digits only!")
          .test(
            "len",
            "Mobile number should be 9 or 10 digits!",
            function (value) {
              if (!value) return false;
              return value.length === 9 || value.length === 10;
            }
          ),
      }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById("submit1");
        submit1.disabled = true;
        submit1.textContent = "Processing...";

        const jsonpar = JSON.stringify({
          first_name: values.first_name,
          last_name: values.last_name,
          userid: values.userid,
          organization_name: values.organization_name,
          location: values.location,
          supervisor: values.supervisor,
          email: values.email,
          mobile: values.mobile,
        });

        const res = await postRequest("update-profile", jsonpar);
        if (res && res.code === 200) {
          localStorage.setItem("fullname", values.first_name + ' ' + values.last_name)
          if(values.first_name){
              localStorage.setItem("fullname", values.first_name + ' ' + values.last_name)
            }else{
              localStorage.setItem("fullname", values.organization_name )
            }
          setAlertData({
            variant: "success",
            message: res.message,
          });
        } else {
          setAlertData({
            variant: "error",
            message: res.message,
          });
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = "Update Profile";
      } catch (error) {
        console.error("Error : ", error);
      }
    },
    context: { userType },
  });

  const handleLoadGetAdminInfo = async () => {
    const res = await getRequest("get-admin-info");
    if (res && res.code === 200) {
      setUserType(res.data.type || "");
      validation1.setValues({
        ...validation1.values,
        first_name: res.data.first_name,
        last_name: res.data.last_name,
        userid: res.data.userid,
        organization_name: res.data.organization_name || "",
        location: res.data.location || "",
        supervisor: res.data.supervisor || "",
        email: res.data.email || "",
        mobile: res.data.mobile || "",
      });
    } else {
      setAlertData({
        variant: "error",
        message: res.message,
      });
    }
    resetAlertData();
  };

  useEffect(() => {
    handleLoadGetAdminInfo();
  }, []);

  return (
    <React.Fragment>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Utilize Safety" breadcrumbItem="Update Profile" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>


                  {userType === 'admin' && (
                    <Row>
                      <Col lg={6} md={6} xs="12">
                        {/* First Name */}
                        <div className="mb-3">
                          <Label className="form-label">First Name</Label>
                          <Input
                            name="first_name"
                            type="text"
                            placeholder="Enter first name"
                            onChange={validation1.handleChange}
                            onBlur={validation1.handleBlur}
                            value={validation1.values.first_name || ""}
                            invalid={validation1.touched.first_name && validation1.errors.first_name ? true : false}
                          />
                          {validation1.touched.first_name && validation1.errors.first_name ? (
                            <FormFeedback type="invalid">{validation1.errors.first_name}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={6} md={6} xs="12">
                        {/* Last Name */}
                        <div className="mb-3">
                          <Label className="form-label">Last Name</Label>
                          <Input
                            name="last_name"
                            type="text"
                            placeholder="Enter last name"
                            onChange={validation1.handleChange}
                            onBlur={validation1.handleBlur}
                            value={validation1.values.last_name || ""}
                            invalid={validation1.touched.last_name && validation1.errors.last_name ? true : false}
                          />
                          {validation1.touched.last_name && validation1.errors.last_name ? (
                            <FormFeedback type="invalid">{validation1.errors.last_name}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                  )}


                  {userType === 'organization' && (
                    <Row>
                      <Col lg={6} md={6} xs="12">
                        {/* Organization Name */}
                        <div className="mb-3">
                          <Label className="form-label">Organization Name</Label>
                          <Input
                            name="organization_name"
                            type="text"
                            placeholder="Enter organization name"
                            onChange={validation1.handleChange}
                            onBlur={validation1.handleBlur}
                            value={validation1.values.organization_name || ""}
                            invalid={validation1.touched.organization_name && validation1.errors.organization_name ? true : false}
                          />
                          {validation1.touched.organization_name && validation1.errors.organization_name ? (
                            <FormFeedback type="invalid">{validation1.errors.organization_name}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={6} md={6} xs="12">
                        {/* Location */}
                        <div className="mb-3">
                          <Label className="form-label">Location</Label>
                          <Input
                            name="location"
                            type="text"
                            placeholder="Enter location"
                            onChange={validation1.handleChange}
                            onBlur={validation1.handleBlur}
                            value={validation1.values.location || ""}
                            invalid={validation1.touched.location && validation1.errors.location ? true : false}
                          />
                          {validation1.touched.location && validation1.errors.location ? (
                            <FormFeedback type="invalid">{validation1.errors.location}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                     
                    </Row>
                  )}

                  <Row>
                    {userType === 'organization' && (
                       <Col lg={6} md={6} xs="12">
                        {/* Supervisor */}
                        <div className="mb-3">
                          <Label className="form-label">Supervisor</Label>
                          <Input
                            name="supervisor"
                            type="text"
                            placeholder="Enter supervisor"
                            onChange={validation1.handleChange}
                            onBlur={validation1.handleBlur}
                            value={validation1.values.supervisor || ""}
                            invalid={validation1.touched.supervisor && validation1.errors.supervisor ? true : false}
                          />
                          {validation1.touched.supervisor && validation1.errors.supervisor ? (
                            <FormFeedback type="invalid">{validation1.errors.supervisor}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    )}
                    <Col lg={6} md={6} xs="12">
                      {/* User Name */}
                      <div className="mb-3">
                        <Label className="form-label">User Name</Label>
                        <Input
                          name="userid"
                          type="text"
                          placeholder="Enter user name"
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          value={validation1.values.userid || ""}
                          invalid={validation1.touched.userid && validation1.errors.userid ? true : false}
                          disabled
                        />
                        {validation1.touched.userid && validation1.errors.userid ? (
                          <FormFeedback type="invalid">{validation1.errors.userid}</FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                  
                  <Row>
                    <Col lg={6} md={6} xs="12">
                      {/* Email */}
                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          type="email"
                          placeholder="Enter email"
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          value={validation1.values.email || ""}
                          invalid={validation1.touched.email && validation1.errors.email ? true : false}
                          disabled
                        />
                        {validation1.touched.email && validation1.errors.email ? (
                          <FormFeedback type="invalid">{validation1.errors.email}</FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col lg={6} md={6} xs="12">
                      {/* Mobile */}
                      <div className="mb-3">
                        <Label className="form-label">Mobile</Label>
                        <Input
                          name="mobile"
                          type="text"
                          placeholder="Enter mobile number"
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          value={validation1.values.mobile || ""}
                          invalid={validation1.touched.mobile && validation1.errors.mobile ? true : false}
                          disabled
                        />
                        {validation1.touched.mobile && validation1.errors.mobile ? (
                          <FormFeedback type="invalid">{validation1.errors.mobile}</FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                  </Row>

                  {/* Buttons */}
                  <div className="text-left mt-4 d-flex gap-2">
                    <Button
                      type="button"
                      color="primary"
                      id="submit1"
                      onClick={(e) => {
                        e.preventDefault();
                        validation1.handleSubmit();
                        return false;
                      }}
                    >
                      Update Profile
                    </Button>

                    <Link
                      to="#"
                      onClick={() => history.goBack()}
                      className="btn btn-light me-2"
                    >
                      Cancel
                    </Link>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
